import BenefitsFormFields from './BenefitsFormFields.component';

export default BenefitsFormFields;
